import { createFileRoute } from '@tanstack/react-router';

import { MySessions } from '#modules/finder/features/posts/components/MySessions';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/sessions/_sessions/profile'
)({
  component: MySessions,
  ssr: false,
});
